<!-- <div class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-w-0">
    <div class="md:flex md:items-center md:justify-end w-full sm:w-auto md:h-full md:w-1/2 py-8 px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card">
        <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
            <div class="w-50">
                <img [src]="_bs.whitelabel().logo" aria-label="logo" alt="logo">
            </div>
            <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight">Sign in</div>
            <div class="flex items-baseline mt-0.5 font-medium">
                <div>Don't have an account?</div>
                <a
                    class="ml-1 text-primary-500 hover:underline"
                    [routerLink]="['/sign-up']">Sign up
                </a>
            </div>
            <fuse-alert
                class="mt-8"
                *ngIf="showAlert"
                [appearance]="'outline'"
                [showIcon]="false"
                [type]="alert.type"
                [@shake]="alert.type === 'error'">
                {{alert.message}}
            </fuse-alert>
            <form
                class="mt-8"
                [formGroup]="signInForm"
                #signInNgForm="ngForm">

                <mat-form-field class="w-full">
                    <mat-label>Enter Tenant Name</mat-label>
                    <input
                        id="company"
                        matInput
                        [formControlName]="'company'">
                    <mat-error *ngIf="signInForm.get('company').hasError('required')">
                        Tenant name is required
                    </mat-error>
                </mat-form-field>
                <div class="flex flex-col items-center gap-2">
                    <button
                        class="fuse-mat-button-large w-full mt-6"
                        mat-flat-button
                        [color]="'primary'"
                        [disabled]="signInForm.disabled"
                        (click)="getPartner()">
                        <span *ngIf="!signInForm.disabled">
                            Sign in
                        </span>
                        <mat-progress-spinner
                            *ngIf="signInForm.disabled"
                            [diameter]="24"
                            [mode]="'indeterminate'"></mat-progress-spinner>
                    </button>
                </div>
            </form>
        </div>
    </div>
    <div class="relative hidden md:flex flex-auto items-center justify-center w-1/2 h-full p-16 lg:px-28 overflow-hidden bg-gray-800 dark:border-l">
        <svg class="absolute inset-0 pointer-events-none"
             viewBox="0 0 960 540" width="100%" height="100%" preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
            <g class="text-gray-700 opacity-25" fill="none" stroke="currentColor" stroke-width="100">
                <circle r="234" cx="196" cy="23"></circle>
                <circle r="234" cx="790" cy="491"></circle>
            </g>
        </svg>
        <svg class="absolute -top-16 -right-16 text-gray-700"
             viewBox="0 0 220 192" width="220" height="192" fill="none">
            <defs>
                <pattern id="837c3e70-6c3a-44e6-8854-cc48c737b659" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width="4" height="4" fill="currentColor"></rect>
                </pattern>
            </defs>
            <rect width="220" height="192" fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"></rect>
        </svg>
        <div class="z-10 relative w-full max-w-2xl">
            <div class="text-7xl font-bold leading-none text-gray-100">
                <div>Welcome to</div>
                <div>ConnectSecure</div>
            </div>
            <div class="mt-6 text-lg tracking-tight leading-6 text-gray-400">
                ConnectSecure provides a straight path to cybersecurity success. Your feedback can become our next upgrade.
                We have weekly calls with our partners to keep our finger on the pulse of your needs.
            </div>
        </div>
    </div>
</div> -->



<div class="flex flex-col bgurl bg-cover bg-center flex-auto items-center sm:justify-center min-w-0">
    <div class="w-full sm:w-auto py-8 px-4 sm:p-12 sm:rounded-2xl sm:shadow sm:bg-card">
        <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">
            <div class="w-50">
                <img [src]="_bs.whitelabel().logo" aria-label="logo" alt="logo">
            </div>
            <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight">Sign in</div>
            <div class="flex items-baseline mt-0.5 font-medium">
                <div>Don't have an account?</div>
                <a
                    class="ml-1 text-primary-500 hover:underline"
                    [routerLink]="['/sign-up']">Sign up
                </a>
            </div>
            <fuse-alert
                class="mt-8"
                *ngIf="showAlert"
                [appearance]="'outline'"
                [showIcon]="false"
                [type]="alert.type"
                [@shake]="alert.type === 'error'">
                {{alert.message}}
            </fuse-alert>
            <form
                class="mt-8"
                [formGroup]="signInForm"
                #signInNgForm="ngForm">

                <mat-form-field class="w-full">
                    <mat-label>Enter Tenant Name</mat-label>
                    <input
                        id="company"
                        matInput
                        [formControlName]="'company'">
                    <mat-error *ngIf="signInForm.get('company').hasError('required')">
                        Tenant name is required
                    </mat-error>
                </mat-form-field>
                <div class="flex flex-col items-center gap-2">
                    <button
                        class="fuse-mat-button-large w-full mt-6"
                        mat-flat-button
                        [color]="'primary'"
                        [disabled]="signInForm.disabled"
                        (click)="getPartner()">
                        <span *ngIf="!signInForm.disabled">
                            Sign in
                        </span>
                        <mat-progress-spinner
                            *ngIf="signInForm.disabled"
                            [diameter]="24"
                            [mode]="'indeterminate'"></mat-progress-spinner>
                    </button>
                    <button
                        class="fuse-mat-button-large w-full mt-6"
                        mat-flat-button
                        [color]="'primary'"
                        [disabled]="signInForm.disabled"
                        (click)="getPartner(true)">
                        <span *ngIf="!signInForm.disabled">
                            Use External Authentication
                        </span>
                        <mat-progress-spinner
                            *ngIf="signInForm.disabled"
                            [diameter]="24"
                            [mode]="'indeterminate'"></mat-progress-spinner>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
